import { TicketPercentOutlineIcon } from './TicketPercentOutlineIcon';

/**
 * author: Özgür Görgülü
 * id 43EDCFCF-4AFB-45E7-8F83-56CC40FC93B7
 * name ticket-percent-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ticket-percent-outline.svg
 * tags
 */
export const CouponOutlineIcon = TicketPercentOutlineIcon;
export default CouponOutlineIcon